import { Directive, Input, Renderer2, ElementRef, RendererStyleFlags2, inject } from "@angular/core";

@Directive({
  selector: "[customIf]",
  standalone: false,
})
export class CustomIfDirective {
  private readonly renderer = inject(Renderer2);
  private readonly el = inject(ElementRef);
  constructor() {}

  @Input()
  set customIf(show: any) {
    this.renderer.setStyle(this.el.nativeElement, "display", show ? "block" : "none", this.flag);
  }

  flag = RendererStyleFlags2.Important;
}
